
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InstallmentContractFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallmentContract"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accelerationDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"applicationDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowedPaymentMethods"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"balance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"principalBalance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"claim"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"daysPastDueDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dueDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extraordinaryPayments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InstallmentExtraordinaryPaymentFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nextInstallment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NextInstallmentFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"installments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InstallmentFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"installmentsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"loanType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interestRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maximumPayment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"maskedPan"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"principal"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"repaymentDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rpsn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"variableSymbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"withdrawalDate"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":849}};
    doc.loc.source = {"body":"#import \"fragments/AmountFragment.graphql\"\n#import \"fragments/InstallmentFragment.graphql\"\n#import \"fragments/InstallmentExtraordinaryPaymentFragment.graphql\"\n#import \"fragments/NextInstallmentFragment.graphql\"\n\nfragment InstallmentContractFragment on InstallmentContract {\n\taccelerationDate\n\tapplicationDate\n\tallowedPaymentMethods\n\tbalance {\n\t\t...AmountFragment\n\t}\n\tprincipalBalance {\n\t\t...AmountFragment\n\t}\n\tclaim {\n\t\t...AmountFragment\n\t}\n\tdaysPastDueDate\n\tdueDate\n\textraordinaryPayments {\n\t\t...InstallmentExtraordinaryPaymentFragment\n\t}\n\tnextInstallment {\n\t\t...NextInstallmentFragment\n\t}\n\tid\n\tinstallments {\n\t\t...InstallmentFragment\n\t}\n\tinstallmentsCount\n\tloanType\n\tinterestRate\n\tmaximumPayment {\n\t\t...AmountFragment\n\t}\n\tmaskedPan\n\tprincipal {\n\t\t...AmountFragment\n\t}\n\trepaymentDate\n\trpsn\n\tsignedAt\n\tstate\n\ttitle\n\tvariableSymbol\n\twithdrawalDate\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("fragments/AmountFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("fragments/InstallmentFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("fragments/InstallmentExtraordinaryPaymentFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("fragments/NextInstallmentFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["InstallmentContractFragment"] = oneQuery(doc, "InstallmentContractFragment");
        
